import { Geo } from '@vercel/functions';
import { proxy } from 'valtio';

const geoState = proxy<{
    geo: Geo | null;
}>({
    geo: null,
});

export { geoState };
